export const mailAndPhoneChangeMessage =
    'Alterações de e-mail e telefone são realizadas pelo nosso time de atendimento.';
